<!--能源指标（横柱状图）-->
<template>
<div class="eindex commonborder flex_row">
  <div id="eindex_bar1" class="echarts"></div>
</div>

</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getTarget().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          let zhibiao = [
            _data.powerTarget,
            _data.waterTarget,
            _data.gasTarget,
            _data.coalTarget,
            _data.fuelTarget,
          ]
          let shiji = [
            _data.powerData,
            _data.waterData,
            _data.gasData,
            _data.coalData,
            _data.fuelData,
          ]
          this.eindex_bar1(zhibiao.reverse(),shiji.reverse())
        }
      })
    },
    eindex_bar1(a,b){
      let eindex_bar1 = echarts.init( document.getElementById('eindex_bar1') );
      eindex_bar1.setOption({
          color:['#0c2667','#24ffb1'],
          tooltip: {
            trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
                type: 'shadow'
            }
          },
          legend: {
              data: ['指标', '实际'],
              right: 'center', top:8,
              textStyle: {
                  color: "#fff",fontSize:this.$echartsFontSize
              },
              itemWidth: 15,itemHeight: 5,
          },
          grid: {
            top: "30px", bottom: "10px",right:'15%',
            containLabel: false,
          },
          xAxis: {
            type: "value",show: false,
          },
          yAxis: {
            type: "category", show:true,axisLine:{show:false},splitLine:{show:false},
            axisLabel:{color:'#fff',fontSize:this.$echartsFontSize},axisTick: { show: false, },
            data: ['电力','水','燃气','煤碳','燃油'].reverse(),
          },
          series: [
            {
              name: "指标",
              type: "bar",
              barWidth: "40%",
              itemStyle: {
                normal: { 
                  label: { show: true,
                    position:'right', 
                    // formatter: '{c}吨',
                    formatter: (params) => {  //格式化数据的函数
                      if(params.name=='电力'){
                        return params.value+' 万度'
                      }else if(params.name=='燃气'){
                        return params.value+' 立方米'
                      }else{
                        return params.value+' 吨'
                      }
                    },
                    color:'#ccd0f2',
                    fontSize:this.$echartsFontSize,
                  },
                  barBorderRadius: 15, borderWidth:1,borderColor:'#0c2667'
                }
              },
              data: a,
            },
            {
              name: "实际",
              type: "bar",
              barWidth: "40%",barGap:'-100%',
              itemStyle: {
                normal: { 
                  label: { 
                    show: true, 
                    // position:'insideRight', 
                    formatter: '{c}',
                    color:'#0a1d91', 
                    fontSize:this.$echartsFontSize,
                    fontWeight:600
                  },
                  barBorderRadius: 15,
                }
              },
              data: b,
            },
          ],
      })
    },
    
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.eindex{
  #eindex_bar1{ height: 100%; width: 100%;}
}
</style>